import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const buttonDefaultVariants = {
  "hierarchy": "primary",
  "color": "accent",
  "size": "medium"
}
const buttonCompoundVariants = [
  {
    "hierarchy": "primary",
    "color": "accent",
    "css": {
      "root": {
        "bg": "background.accent.primary",
        "color": "content.default.level-5",
        "_hover": {
          "bg": "background.accent.primary.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.info"
        }
      }
    }
  },
  {
    "hierarchy": "primary",
    "color": "neutral",
    "css": {
      "root": {
        "bg": "background.accent.secondary",
        "color": "content.default.level-0",
        "_hover": {
          "bg": "background.accent.secondary.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.default.level-4"
        }
      }
    }
  },
  {
    "hierarchy": "primary",
    "color": "buy",
    "css": {
      "root": {
        "bg": "background.accent.buy",
        "color": "content.default.level-5",
        "_hover": {
          "bg": "background.accent.buy.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.buy"
        }
      }
    }
  },
  {
    "hierarchy": "primary",
    "color": "sell",
    "css": {
      "root": {
        "bg": "background.accent.sell",
        "color": "content.default.level-5",
        "_hover": {
          "bg": "background.accent.sell.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.sell"
        }
      }
    }
  },
  {
    "hierarchy": "secondary",
    "color": "accent",
    "css": {
      "root": {
        "color": "content.accent.info",
        "border": "1px solid {colors.border.accent.info}",
        "_hover": {
          "color": "content.accent.info.hover",
          "borderColor": "border.accent.info.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.info"
        }
      }
    }
  },
  {
    "hierarchy": "secondary",
    "color": "neutral",
    "css": {
      "root": {
        "color": "content.default.level-4",
        "border": "1px solid {colors.border.default.level-3}",
        "_hover": {
          "color": "content.interaction.hover",
          "borderColor": "border.interaction.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.default.level-4"
        }
      }
    }
  },
  {
    "hierarchy": "secondary",
    "color": "buy",
    "css": {
      "root": {
        "color": "content.accent.buy",
        "border": "1px solid {colors.border.accent.buy}",
        "_hover": {
          "color": "content.accent.buy.hover",
          "borderColor": "border.accent.buy.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.buy"
        }
      }
    }
  },
  {
    "hierarchy": "secondary",
    "color": "sell",
    "css": {
      "root": {
        "color": "content.accent.sell",
        "border": "1px solid {colors.border.accent.sell}",
        "_hover": {
          "color": "content.accent.sell.hover",
          "borderColor": "border.accent.sell.hover"
        },
        "_focusVisible": {
          "outlineColor": "border.accent.sell"
        }
      }
    }
  },
  {
    "css": {
      "root": {
        "_disabled": {
          "bg": "background.interaction.disabled",
          "color": "content.interaction.disabled",
          "border": "none",
          "_hover": {
            "bg": "background.interaction.disabled",
            "color": "content.interaction.disabled",
            "border": "none"
          }
        }
      }
    }
  }
]

const buttonSlotNames = [
  [
    "root",
    "button__root"
  ],
  [
    "label",
    "button__label"
  ],
  [
    "subLabel",
    "button__subLabel"
  ],
  [
    "icon",
    "button__icon"
  ],
  [
    "spinner",
    "button__spinner"
  ]
]
const buttonSlotFns = /* @__PURE__ */ buttonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonDefaultVariants, getSlotCompoundVariant(buttonCompoundVariants, slotName))])

const buttonFn = memo((props = {}) => {
  return Object.fromEntries(buttonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonVariantKeys = [
  "hierarchy",
  "color",
  "size"
]
const getVariantProps = (variants) => ({ ...buttonDefaultVariants, ...compact(variants) })

export const button = /* @__PURE__ */ Object.assign(buttonFn, {
  __recipe__: false,
  __name__: 'button',
  raw: (props) => props,
  variantKeys: buttonVariantKeys,
  variantMap: {
  "hierarchy": [
    "primary",
    "secondary"
  ],
  "color": [
    "accent",
    "neutral",
    "buy",
    "sell"
  ],
  "size": [
    "large",
    "medium",
    "small"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps
})